import * as React from "react";
import AnnotationGeometry from "./AnnotationGeometry";
import { useAnnotationActions } from "context/";

const AnnotationPolygon = ({ annotation }) => {
  const { addPolygon } = useAnnotationActions();

  return <AnnotationGeometry
    annotation={annotation}
    addGeometry={addPolygon}
  />;
};

export default AnnotationPolygon;
